import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-buzon',
  templateUrl: './buzon.component.html',
  styleUrls: ['./buzon.component.css']
})
export class BuzonComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
